<template>
  <div class="hy-order">
    <div class="order-cont">
      <!--活动简介-->
      <div class="order-topTitle">
        <div class="title">
          <h5>{{ conference.conference.name }}</h5>
        </div>
        <div class="infotimes" style="margin-top:10px;">
          <span class="iconfont">&#xe671;</span>主办单位：{{ conference.conference.organizers ==
            '' ? '无' : conference.conference.organizers }}
        </div>
        <!-- <div class="infotimes">
          <span class="iconfont">&#xe6bb;</span>承办单位：{{conference.conference.company == ''?'无':conference.conference.company}}
        </div> -->
        <div class="infotimes infotimes_width_label_content" style="display: flex;"
          v-if="id != '5664' && conference.company != ''">
          <div class="label" style="white-space: nowrap">
            <span class="iconfont">&#xe6bb;</span>
            <span>承办单位：</span>
          </div>
          <div class="content" style="display: flex; flex-direction: column; flex: auto;">
            <div v-for="(i, index) in conference.company?.split(' ')" :key="index">{{ i }}</div>
          </div>
        </div>
        <div class="infotimes">
          <span
            class="iconfont">&#xe67f;</span>会议时间：{{ conference.conference.start_time, 'Y-M-D' | formatDates }}~{{ conference.conference.end_time, 'Y-M-D' | formatDates }}
        </div>
        <div class="infotimes">
          <span
            class="iconfont">&#xe64d;</span>会议地点：{{ conference.conference.region }}{{ conference.conference.specific_address }}
        </div>
      </div>
      <!-- 填写购票信息-->
      <div class="order-addPeople">
        <h5>为保证会议门票的正常使用，请填写参会人信息</h5>
        <!--循环票种类-->
        <template v-for="(piao, piao_index) in cartbox.conf_ticket_arr">
          <div class="add_items" v-for="(items2, p_index) in piao.member">
            <!--循环各类型票的购买数量-->
            <div class="add_top">
              <div class="l">
                <p>参会人信息</p>
                <p class="name">{{ piao.name }}1张</p>
              </div>
              <div class="r">
                <!--<span class="add_btn">保存</span>-->
              </div>
            </div>
            <div class="add_box">
              <!-- 循环字段-->
              <div v-for="(items, index) in field_box" :key="index">
                <template v-if="items.relation_status != 1">
                  <!-- 搜索选择-->
                  <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-if="items.form_type == 7"
                    v-model="items2.filed[index].value" :label="items.field + '：'"
                    :placeholder="items.tips ? items.tips : '点击选择'" @click="showZdybox(piao_index, p_index, index)"
                    readonly />
                  <!-- 文本输入框-->
                  <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-if="items.form_type == 1"
                    v-model="items2.filed[index].value" :label="items.field + '：'"
                    :placeholder="items.tips ? items.tips : '请输入内容'"
                    :maxlength="items.maxlength == 0 ? '100' : items.maxlength"
                    @blur="validator(piao_index, p_index, index)" />
                  <!--多行文本-->
                  <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-else-if="items.form_type == 2" rows="2"
                    type="textarea" :maxlength="items.maxlength == 0 ? '' : items.maxlength"
                    v-model="items2.filed[index].value" show-word-limit :label="items.field + '：'"
                    :placeholder="items.setting.defaultvalue ? items.tips : '请输入内容'" style="height:auto;"
                    @blur="validator(piao_index, p_index, index)" />
                  <!-- 单选框 -->
                  <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '' : 'active'"
                    v-else-if="items.form_type == 3">
                    <h5>{{ items.field }}：</h5>
                    <van-radio-group v-model="items2.filed[index].value" direction="horizontal"
                      @change="checkedChang(piao_index, p_index, index)">
                      <!--循环单选框-->
                      <van-radio :name="optionsItems" v-for="optionsItems in items.options">{{ optionsItems }}</van-radio>
                    </van-radio-group>
                  </div>
                  <!-- 复选框 -->
                  <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '' : 'active'"
                    v-else-if="items.form_type == 4">
                    <h5>{{ items.field }}：</h5>
                    <van-checkbox-group v-model="items2.filed[index].value" direction="horizontal"
                      @change="checkedChang(piao_index, p_index, index)">
                      <van-checkbox shape="square" :name="optionsItems"
                        v-for="optionsItems in items.options">{{ optionsItems }}</van-checkbox>
                    </van-checkbox-group>
                  </div>
                  <!--下拉选择-->
                  <div class="van-select-groupbox" :class="items2.filed[index].is_click ? '' : 'active'"
                    v-else-if="items.form_type == 5">
                    <div class="van-select-label">
                      {{ items.field }}：
                    </div>
                    <van-dropdown-menu>
                      <van-dropdown-item v-model="items2.filed[index].value"
                        :title="items2.filed[index].value == '' ? '请选择' : ''" :options="items.options"
                        @change="checkedChang(piao_index, p_index, index)">
                      </van-dropdown-item>
                    </van-dropdown-menu>
                  </div>
                  <!--选择日期-->
                  <div class="van-check-time" :class="items2.filed[index].is_click ? '' : 'active'"
                    v-else-if="items.form_type == 6">
                    <van-cell :title="items.field + '：'"
                      :value="items2.filed[index].value == '' ? '请选择' : items2.filed[index].value"
                      @click="open_datetimePicker([piao_index, p_index, index], 'date')" />
                  </div>
                </template>
                <template v-else>
                  <template v-for="(rela, rIndex)  in field_box" v-if="rela.id == items.relation_field_id">
                    <template v-if="items2.filed[rIndex].value == items.relation_field_val">
                      <!-- 搜索选择-->
                      <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-if="items.form_type == 7"
                        v-model="items2.filed[index].value" :label="items.field + '：'"
                        :placeholder="items.tips ? items.tips : '点击选择'" @click="showZdybox(piao_index, p_index, index)"
                        readonly />
                      <!-- 文本输入框-->
                      <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-if="items.form_type == 1"
                        v-model="items2.filed[index].value" :label="items.field + '：'"
                        :placeholder="items.tips ? items.tips : '请输入内容'"
                        :maxlength="items.maxlength == 0 ? '100' : items.maxlength"
                        @blur="validator(piao_index, p_index, index)" />
                      <!--多行文本-->
                      <van-field :class="items2.filed[index].is_click ? '' : 'active'" v-else-if="items.form_type == 2"
                        rows="2" type="textarea" :maxlength="items.maxlength == 0 ? '' : items.maxlength"
                        v-model="items2.filed[index].value" show-word-limit :label="items.field + '：'"
                        :placeholder="items.setting.defaultvalue ? items.tips : '请输入内容'" style="height:auto;"
                        @blur="validator(piao_index, p_index, index)" />
                      <!-- 单选框 -->
                      <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '' : 'active'"
                        v-else-if="items.form_type == 3">
                        <h5>{{ items.field }}：</h5>
                        <van-radio-group v-model="items2.filed[index].value" direction="horizontal"
                          @change="checkedChang(piao_index, p_index, index)">
                          <!--循环单选框-->
                          <van-radio :name="optionsItems"
                            v-for="optionsItems in items.options">{{ optionsItems }}</van-radio>
                        </van-radio-group>
                      </div>
                      <!-- 复选框 -->
                      <div class="van-radio-groupBox" :class="items2.filed[index].is_click ? '' : 'active'"
                        v-else-if="items.form_type == 4">
                        <h5>{{ items.field }}：</h5>
                        <van-checkbox-group v-model="items2.filed[index].value" direction="horizontal"
                          @change="checkedChang(piao_index, p_index, index)">
                          <van-checkbox shape="square" :name="optionsItems"
                            v-for="optionsItems in items.options">{{ optionsItems }}</van-checkbox>
                        </van-checkbox-group>
                      </div>
                      <!--下拉选择-->
                      <div class="van-select-groupbox" :class="items2.filed[index].is_click ? '' : 'active'"
                        v-else-if="items.form_type == 5">
                        <div class="van-select-label">
                          {{ items.field }}：
                        </div>
                        <van-dropdown-menu>
                          <van-dropdown-item v-model="items2.filed[index].value"
                            :title="items2.filed[index].value == '' ? '请选择' : ''" :options="items.options"
                            @change="checkedChang(piao_index, p_index, index)">
                          </van-dropdown-item>
                        </van-dropdown-menu>
                      </div>
                      <!--选择日期-->
                      <div class="van-check-time" :class="items2.filed[index].is_click ? '' : 'active'"
                        v-else-if="items.form_type == 6">
                        <van-cell :title="items.field + '：'"
                          :value="items2.filed[index].value == '' ? '请选择' : items2.filed[index].value"
                          @click="open_datetimePicker([piao_index, p_index, index], 'date')" />
                      </div>
                    </template>
                  </template>
                </template>
              </div>
              <div>
                <van-checkbox v-model="items2.main" shape="square">设为主要联系人</van-checkbox>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!--报名须知-->
      <div class="order_xuzhi">
        <div class="title">
          <h5>报名须知</h5>
        </div>
        <div class="xuzhi_info">
          {{ conference.conference.ticket_desc }}
        </div>
      </div>
    </div>
    <!--订单页底部提交栏-->
    <div class="order_addbtnbox">
      <div class="addbox">
        <div class="r" style="width:100%;">
          <span class="order_btn" @click="addPiaoCont()">保存信息</span>
        </div>
      </div>
    </div>
    <!--底部按钮-->
    <template v-if="conference.conference.name != ''">
      <footerFixed :id="conference.conference.id" :jump-page="conference.conference.jump_page" />
    </template>


    <!--DatetimePicker时间选择器-->
    <div class="dateTimePicker">
      <van-popup v-model="datetimePicke.show" :position="datetimePicke.position" style="z-index:2010!important;">
        <van-datetime-picker v-model="datetimePicke.default_date" :type="datetimePicke.type" :title="datetimePicke.title"
          :min-date="datetimePicke.min_date" :max-date="datetimePicke.max_date" @confirm="datetimePickerConfirm"
          @cancel="onCancel()" />
      </van-popup>
    </div>
    <!--搜索下拉自定义字段选择-->
    <van-popup v-model="zdybox.show" class="zdyBox" round position="bottom" :style="{ height: '70%' }" closeable>
      <van-field v-model="zdybox.value" placeholder="请输入" class="input" @keyup="zdySearchKeyUp" />
      <div class="list">
        <template v-if="zdybox.list.length > 0">
          <van-radio-group v-model="zdybox.radio" v-if="zdybox.is_pishu_group != 1">
            <van-cell-group>
              <van-cell :title="item" clickable v-for="item in zdybox.list" @click="zdybox.radio = item">
                <template #right-icon>
                  <van-radio :name="item" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <van-radio-group v-model="zdybox.radio" v-else>
          <van-cell-group>
            <van-cell :title="item.name" clickable v-for="(item,zdyindex) in zdybox.list" @click="zdyboxChecked(item.name,zdyindex)">
              <template #right-icon>
                <van-radio :name="item.name"  :disabled="item.last_num < 1?true:false"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        </template>
        <p v-else>{{ zdybox.tishi }}</p>
      </div>
      <van-button class="buttonBtn" type="primary" block @click="zdyBaocun">保存选项</van-button>
    </van-popup>
  </div>
</template>


<script>
import { formatDates, formatWeekDate } from "../../assets/js/date";
import footerFixed from '@/components/common/fixed_setting'
export default {
  components: {
    footerFixed
  },
  data() {
    return {
      id: '',
      order_show: false,
      footerNav: false,
      //DatetimePicker 时间选择
      datetimePicke: {
        show: false,
        type: 'datetime',//时间类型，可选值为 date time  year-month month-day
        title: '日历',//	顶部栏标题
        confirm_button_text: '确定',//确认按钮文字区间
        cancel_button_text: '取消',//取消按钮文字
        visible_item_count: '5',//	可见的选项个数
        min_date: new Date(new Date().getTime() - 365 * 10 * 24 * 3600 * 1000),//可选的最小时间，精确到分钟
        max_date: new Date(new Date().getTime() + 365 * 10 * 24 * 3600 * 1000),//可选的最大时间，精确到分钟
        position: 'bottom',//弹出位置，可选值为 top right left
        default_date: new Date(),//默认值
        isOndata: '',//数据
      },
      //报名字段初始化数据
      field_box: {},
      //会议信息
      conference: {
        conference: {
          name: ''
        }
      },
      //购物车信息
      cartbox: {
        conf_ticket_arr: [
          {
            "id": '',
            "name": "",
            "price": "",
            "quantity": 1,
            "type": 20,
            "member": []
          }],
      },
      allId: {},//会议id 门票id 订单号
      zdybox: {
        show: false,
        list: [],
        tishi: "没有搜索到您输入的选项",
        inputOn: [],
        value: '',
        radio: '',
        placeholder: ''
      }
    };
  },
  /* 时间过滤 */
  filters: {
    formatDates,//调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
    formatWeekDate //
  },
  created: function () {
    var _this = this;
    _this.id = parseInt(_this.$route.params.id);
    _this.allId = JSON.parse(sessionStorage.getItem('order_isok_' + _this.id));
    _this.loadEnroll();
    _this.$WXConfig.wxShowMenu({ ifshare: true, that: _this, data: '' });
  },
  methods: {
      //自定义下拉选中
      zdyboxChecked(name,index){
      var _this = this;
      if(_this.zdybox.list[index].last_num > 0){
        _this.zdybox.radio = name;
      } 
    },
    //自定义下拉点击
    showZdybox(i, n, s) {
      var _this = this;
      var boxs = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
      var filed_box = _this.field_box[s];
      _this.zdybox.radio = boxs.value;
      _this.zdybox.value = boxs.value;
      if(filed_box.is_pishu_group != 1){
          _this.zdybox.list = filed_box.options;
        }else{
          _this.zdybox.list = filed_box.options_num;
        }  
      _this.zdybox.inputOn = [i, n, s];
      _this.zdybox.placeholder = filed_box.tips;
        _this.zdybox.is_pishu_group = filed_box.is_pishu_group;
      _this.zdybox.show = true;
      if (boxs.value) {
        _this.zdySearchKeyUp();
      }
    },
    //自定义字段搜索下拉
    zdySearchKeyUp() {
      var _this = this;
      var inputText = _this.zdybox.value;
      var list = _this.field_box[_this.zdybox.inputOn[2]].is_pishu_group !=1? _this.field_box[_this.zdybox.inputOn[2]].options:_this.field_box[_this.zdybox.inputOn[2]].options_num;
      _this.zdybox.radio = '';
      _this.zdybox.list = [];
      var zhi = '';
      for (var i = 0; i < list.length; i++) {
        zhi = list[i];
        if(_this.zdybox.is_pishu_group != 1){
            if (zhi.indexOf(inputText) != -1) { //因为indexof找不到的时候是一律为-1，所以直接判断是否为-1，不是就弹出这个值
            _this.zdybox.list.push(list[i]); //将值放入第二个数组
          }
          }else{
            if (zhi.name.indexOf(inputText) != -1) { //因为indexof找不到的时候是一律为-1，所以直接判断是否为-1，不是就弹出这个值
            _this.zdybox.list.push(list[i]); //将值放入第二个数组
          }
          }
      }
    },
    //自定义字段搜索保存
    zdyBaocun() {
      var _this = this;
      if (_this.zdybox.radio === '') {
        _this.$toast('请选择选项！');
        return false;
      } 
      _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].value = _this.zdybox.radio;
      _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].is_click = true;
      _this.cartbox.conf_ticket_arr[_this.zdybox.inputOn[0]].member[_this.zdybox.inputOn[1]].filed[_this.zdybox.inputOn[2]].is_required = true;
      _this.zdybox.show = false;
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(i, n, s) {
      var _this = this;
      var car_filed = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
      var filed_box = _this.field_box[s];
      var regular = new RegExp(filed_box.pattern);
      if (filed_box.is_required) {
        if (car_filed.value != '') {
          if (!(regular.test(car_filed.value))) {
            car_filed.is_click = false;
            car_filed.is_required = false;
            _this.$toast(_this.field_box[s].errortips);
          } else {
            car_filed.is_click = true;
            car_filed.is_required = true;
          }
        } else {
          _this.$toast(_this.field_box[s].errortips);
          car_filed.is_click = false;
          car_filed.is_required = false;
        }
      } else {
        if (car_filed.value != '') {
          if (!(regular.test(car_filed.value))) {
            car_filed.is_click = false;
            car_filed.is_required = false;
            _this.$toast(_this.field_box[s].errortips);
          } else {
            car_filed.is_click = true;
            car_filed.is_required = true;
          }
        }
      }
    },
    checkedChang(i, n, s) {
      var _this = this;
      var car_filed = _this.cartbox.conf_ticket_arr[i].member[n].filed[s];
      var filed_box = _this.field_box[s];
      if (filed_box.is_required) {
        if (filed_box.form_type == 4) {
          if (car_filed.value.length == 0) {
            car_filed.is_click = false;
            car_filed.is_required = false;
            _this.$toast(_this.field_box[s].errortips);
          } else {
            car_filed.is_click = true;
            car_filed.is_required = true;
          }
        } else {
          if (car_filed.value == '') {
            car_filed.is_click = false;
            car_filed.is_required = false;
            _this.$toast(_this.field_box[s].errortips);
          } else {
            car_filed.is_click = true;
            car_filed.is_required = true;
          }
        }
      }
    },
    //banner跳转方法
    goPath(path) {
      this.$router.push(path)
    },
    //打开底部链接
    openFooterNav(val) {
      //   this.$toast(val);
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    },
    //加载初始化内容
    loadEnroll() {
      var _this = this;
      let url = ['/ac1/conference/enrollField', "/ac1/conference/addTicketPage"];
      let params = [{
        id: _this.allId.c_id
      }, {
        id: _this.id
      }];
      _this.$get(url[0], params[0]).then(res => {
        if (res.code == "1") {
          _this.field_box = res.posts;
          var filed = [], main = _this.allId.main;
          for (var j = 0; j < _this.field_box.length; j++) {
            var s = _this.field_box[j];
            var val = '';
            if (s.form_type == 4) {
              val = [];
            }
            if (s.form_type == 6) {
              val = '';
            }
            var is_required = false;
            if (s.is_required == 0) {
              is_required = true;
            }
            var list = {
              id: s.id,
              name: s.field,
              field_name: s.field_name,
              value: val,
              is_required: is_required,
              is_click: true
            }
            filed.push(list);
          }

          for (var i = 0; i < _this.allId.fields.length; i++) {
            for (var j = 0; j < filed.length; j++) {
              if (_this.allId.fields[i].field_name == filed[j].field_name) {
                var s = _this.allId.fields[i];
                var val = s.value;
                if (s.form_type == 4) {
                  val = [];
                }
                if (s.form_type == 6) {
                  val = '';
                }
                var is_required = false;
                if (s.is_required == 0) {
                  is_required = true;
                }
                var lists = {
                  id: s.id,
                  name: s.name,
                  field_name: s.field_name,
                  value: val,
                  is_required: true,
                  is_click: true
                }
                filed[j] = lists;
              }
            }
          }
          _this.cartbox.conf_ticket_arr[0].member.push({ piao_num: '1', name: filed[0].value, tel: filed[1].value, filed: filed, main: main });
          _this.field_box.forEach(s => {
            if (s.form_type == 5) {
              var optionslist = [];
              for (var i = 0; i < s.options.length; i++) {
                optionslist.push({ text: s.options[i], value: s.options[i] });
              }
              s.options = optionslist;
            }
          });
        }
      });
      _this.$get(url[1], params[1]).then(res => {
        if (res.code == "1") {
          _this.conference = res.posts;
          _this.cartbox.conf_ticket_arr[0].name = res.posts.ticket.name;
          _this.cartbox.conf_ticket_arr[0].id = res.posts.ticket.id;
          _this.cartbox.conf_ticket_arr[0].price = res.posts.ticket.price;
        }
      });
    },
    show_orderBox() {
      this.order_show = !this.order_show;
    },
    //日期选择
    open_datetimePicker(i, n) {
      var _this = this;
      _this.datetimePicke.show = true;
      if (_this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]].value != '') {
        _this.datetimePicke.default_date = new Date(_this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]].value);
      } else {
        _this.datetimePicke.default_date = new Date();
      }
      _this.datetimePicke.isOndata
        = _this.cartbox.conf_ticket_arr[i[0]].member[i[1]].filed[i[2]];
    },
    //确认选择日期
    datetimePickerConfirm(date) {
      var _this = this;
      _this.datetimePicke.show = false;
      _this.datetimePicke.isOndata.value = _this.$options.filters['formatDates'](date / 1000, 'Y/M/D h:m');
      _this.datetimePicke.isOndata.is_click = true;
      _this.datetimePicke.isOndata.is_required = true;
    },

    //提交订单
    addPiaoCont() {
      var _this = this;
      var status = true;
      for (var i = 0; i < _this.cartbox.conf_ticket_arr.length; i++) {
        var lists = _this.cartbox.conf_ticket_arr[i];
        for (var j = 0; j < lists.member.length; j++) {
          var lists2 = lists.member[j];
          lists2.name = lists2.filed[0].value;
          lists2.tel = lists2.filed[1].value;
          for (var h = 0; h < lists2.filed.length; h++) {
            var filedbox = _this.cartbox.conf_ticket_arr[i].member[j].filed[h];
            var relaStatus = true;
            if (_this.field_box[h].relation_status == 1) {
              for (var rela = 0; rela < _this.field_box.length; rela++) {
                if (_this.field_box[h].relation_field_id == _this.field_box[rela].id) {
                  if (_this.field_box[h].relation_field_val != _this.cartbox.conf_ticket_arr[i].member[j].filed[rela].value) {
                    relaStatus = false;
                    _this.cartbox.conf_ticket_arr[i].member[j].filed[h].value = '';
                  }
                }
              }
            }
            if (relaStatus) {
              if (!filedbox.is_required) {
                filedbox.is_click = false;
                _this.$toast(_this.field_box[h].errortips);
                status = false;
                return false;
              }
            }
          }
        }
      }
      if (status) {
        let url = "/ac1/conference/enroll/saveMmeber";
        let params = {
          ticket_id: _this.allId.t_id,
          name: _this.cartbox.conf_ticket_arr[0].member[0].name,
          tel: _this.cartbox.conf_ticket_arr[0].member[0].tel,
          main: _this.cartbox.conf_ticket_arr[0].member[0].main,
          order_no: _this.allId.order_no,
          conference_id: _this.allId.c_id,
          fields: _this.cartbox.conf_ticket_arr[0].member[0].filed,
          id: _this.allId.has_id,
          main: _this.cartbox.conf_ticket_arr[0].member[0].main
        };
        _this.$post(url, params).then(res => {
          if (res.code == "1") {
            _this.$toast(res.msg);
            setTimeout(function () {
              _this.$router.go(-1);
            }, 1000)
          } else {
            _this.$toast(res.msg);
          }
        }, function (res) {
          _this.$toast(res.msg);
        });
      }
    }
  },
  mounted() { }
}
</script>
<style lang="less" scoped></style>
</style>
